export default "__VITE_ASSET__C6VvNVy4__"